import { CarriedInterestDayCountFormat } from 'further-types/lp/carry-settings';

export default function useDayCountOptions() {
  return [
    {
      label: 'Actual/Actual',
      value: CarriedInterestDayCountFormat.ActualActual,
      description:
        'Calculates daily interest using the actual number of days in the year and then multiplies that by the actual number of days in each time period.',
    },
    {
      label: 'Actual/365',
      value: CarriedInterestDayCountFormat.Actual365,
      description:
        'Calculates daily interest using a 365-day year and then multiplies that by the actual number of days in each time period.',
    },
    {
      label: 'Actual/360',
      value: CarriedInterestDayCountFormat.Actual360,
      description:
        'Calculates daily interest using a 360-day year and then multiplies that by the actual number of days in each time period.',
    },
    {
      label: '30/365',
      value: CarriedInterestDayCountFormat.Fixed30By365,
      description:
        'Calculates daily interest using a 365-day year, with each full month being counted as 30 days.',
    },
    {
      label: '30/360',
      value: CarriedInterestDayCountFormat.Fixed30By360,
      description:
        'Calculates daily interest using a 360-day year, with each full month being counted as 30 days.',
    },
  ];
}
